import Backbone from "backbone";
import DriveView, { IDriveViewOptions } from "../DriveView";
import { show, hide } from "../utils/vanilla";

interface ISubnavigationBaseViewOptions<T extends Backbone.Model> extends IDriveViewOptions<T> {
    active: string;
}

/**
 * Any view that uses the subnavigation container that exists in app.view.tmpl.
 * Currently in use by HOS, Messaging, and Inspection pages
 *
 * KNOWN ISSUE (MYG-143588): the constructor appends to #submenu-container without clearing
 * it, and remove() only hides the container — it never detaches this.el. A view whose
 * reference is dropped before remove() runs therefore leaves its #submenu attached forever,
 * and the next view stacks another one on top (Prime saw 2-5 bars until reload). The known
 * way to drop a reference like that was the re-entrant unlock in AppView.lockScreen, whose
 * trigger is now fixed at source, so this is documented rather than changed — clearing
 * children here would alter DOM behaviour for HOS, Messaging, and Inspection at once. If it
 * is fixed later, detach this.el in remove() and clear stale children before appending.
 */
export default class SubnavigationBaseView extends DriveView<Backbone.Model> {
    constructor(readonly options: ISubnavigationBaseViewOptions<Backbone.Model>) {
        super(options);
        let el = document.createElement("div");
        el.id = "submenu";
        this.setElement(el);
        let containerEl = document.getElementById("submenu-container");
        if (containerEl) {
            containerEl.setAttribute("aria-labelledBy", "title");
            containerEl.appendChild(this.el);
            show(containerEl);
        }
    }

    remove() {
        let containerEl = document.getElementById("submenu-container");
        containerEl && hide(containerEl);
        super.remove();
        return this;
    }
}